import { Button } from "@herskin/ui";
import { IconRefresh } from "@tabler/icons-react";
import { Component, type ErrorInfo, type ReactNode } from "react";

interface AppErrorBoundaryProps {
  children: ReactNode;
}

interface AppErrorBoundaryState {
  failed: boolean;
}

/**
 * 最外层安全网：真实数据或浏览器差异引发未捕获渲染异常时，保留可理解、可恢复的界面。
 * 错误堆栈只写浏览器开发控制台，不渲染到页面，避免泄漏运行细节。
 */
export class AppErrorBoundary extends Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
  override state: AppErrorBoundaryState = { failed: false };

  static getDerivedStateFromError(): AppErrorBoundaryState {
    return { failed: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("HerSkin 前端发生未捕获渲染异常", error, info);
  }

  override render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main className="fatal-screen" role="alert">
        <div className="brand-mark" aria-hidden="true">
          F
        </div>
        <h1>页面暂时无法显示</h1>
        <p>HerSkin 已保留登录状态和服务器数据。重新载入后仍异常时，可前往诊断日志查看详情。</p>
        <Button leadingIcon={<IconRefresh size={17} />} onClick={() => window.location.reload()}>
          重新载入
        </Button>
      </main>
    );
  }
}
